import { useMemo } from 'react'
import { btoa } from '@ztechapps/common.utils'
import isEmpty from 'lodash/isEmpty'

export type UsePdfViewerResult = {
  url?: string
}

export const usePdfViewer = (sourceUrl: string): UsePdfViewerResult => {
  const url = useMemo(() => {
    if (isEmpty(sourceUrl)) return null

    const params = btoa({ url: sourceUrl ?? '' })
    const fileName = 'file.pdf'
    return `/api/pdf-viewer/${params}/${fileName}`
  }, [sourceUrl])

  return { url }
}
